import React, { useEffect, useRef } from 'react';
import { EnvironmentBanner } from 'shared-ui';
import env from 'env';
import styles from './StagingBanner.module.css';

const HEIGHT_VAR = '--env-banner-height';

const StagingBanner = () => {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const banner = ref.current;
        if (!banner) return;
        const observer = new ResizeObserver(() => {
            document.documentElement.style.setProperty(HEIGHT_VAR, `${banner.offsetHeight}px`);
        });
        observer.observe(banner);
        return () => {
            observer.disconnect();
            document.documentElement.style.removeProperty(HEIGHT_VAR);
        };
    }, []);

    if (!env.IS_STAGING) return null;

    return (
        <div ref={ref} className={styles.banner}>
            <EnvironmentBanner environment="staging" productionUrl={env.PRODUCTION_DASHBOARD_URL} />
        </div>
    );
};

export default StagingBanner;
